import React from "react";
import ebautPhotoOne from "../../img/new-1.jpg";
import ebautPhotoTwo from "../../img/new-2.jpg";
import linies from "../../img/linies.png";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';


function EbAutOne({ebautData}) {

    //console.log(ebautData);

    return (
        <>
            {
                ebautData ?
                    <section className="eut-abot relative pb-10 lg:pb-40" id="ebaut">
                        <div className="container w-[90%] max-w-screen-lg lg:w-3/4 mx-auto rounded-2xl">
                            <div
                                className="md:flex flex-wrap items-center md:flex-wrap lg:justify-center relative z-20">

                                <div className="relative z-[1] shrink-0 flex justify-end w-full md:w-1/2 mb-[120px] lg:mb-0">
                                    <img src={ebautPhotoOne} alt="image"
                                         className="shrink-0 rounded-[50px] w-3/4 border-[10px] border-[#E7E9EC]"/>
                                    <img src={ebautPhotoTwo} alt="image"
                                         className="et-about-floating-img w-4/5 absolute top-[55px] -left-[20px] lg:-left-[80px] shrink-0 rounded-[20px] border-white border-[10px] shadow-[0_4px_40px_0_rgba(0,0,0,0.1)] xs:hidden"/>
                                </div>

                                <div className="w-full md:w-1/2 ps-0 lg:ps-9 order-1 lg:order-2">
                                    <ScrollAnimation animateIn="animate__fadeInUp"><h6 className="bg-[#F3FF80] w-max px-3 py-1 mb-4 rounded-2xl">Про івент</h6></ScrollAnimation>
                                    <ScrollAnimation animateIn="animate__fadeInUp"><h2 className="text-4xl mb-4 uppercase">{ebautData.ebaut_title}</h2></ScrollAnimation>
                                    <ScrollAnimation animateIn="animate__fadeInUp"><p className="mb-[30px] text-[16px] font-light text-etGray md:mb-[30px] rev-slide-up">
                                        {ebautData.ebaut_text}
                                    </p></ScrollAnimation>
                                </div>

                            </div>

                            <div className="!bg-contain w-full absolute left-0 top-0 h-full opacity-10 z-10"
                                 style={{background: "url(" + linies + ")"}}></div>
                        </div>
                    </section> : ''
            }
        </>
    )
}

export default EbAutOne